import { AxiosMethods, CommonApi } from '../../../../enums';
import { axiosHelper } from '../../../axios-instance';
import { SlackAPIErrorBody } from './types';

export enum SlackMutationKeys {
  SEND_CHANNEL_MSG = 'send-channel-message',
  API_ERROR_MSG = 'api-error-message'
}

export const sendMessageToSlackChannel = () => ({
  mutationKey: [SlackMutationKeys.SEND_CHANNEL_MSG],
  mutationFn: (body: any) =>
    axiosHelper({
      endpoint: CommonApi.SlackChannelMessages,
      method: AxiosMethods.POST,
      baseURL: process.env.REVOPS_API,
      body
    })
});

export const sendAPIErrorToSlackChannel = () => ({
  mutationKey: [SlackMutationKeys.API_ERROR_MSG],
  mutationFn: (body: SlackAPIErrorBody) =>
    axiosHelper({
      endpoint: CommonApi.SlackChannelAPIError,
      method: AxiosMethods.POST,
      baseURL: process.env.REVOPS_API,
      body
    })
});
